import { Box, chakra, Flex, Image, Text } from '@chakra-ui/react';
import { Color } from 'presentation/theme/colorScheme';
import { FC, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  iconSrc: string;
  label: string;
  showBorder?: boolean;
}

const SelfIpoParamRow: FC<Props> = ({
  iconSrc,
  label,
  children,
  showBorder = true,
  ...props
}) => {
  return (
    <Flex
      alignItems="flex-start"
      borderBottom={showBorder ? '1px solid' : 'none'}
      borderBottomColor={Color.Shade100}
      py="10px"
      w="100%"
      {...props}
    >
      <Image src={iconSrc} alt="" boxSize="22px" flexShrink={0} mr="14px" />
      <Text
        flex={{ base: '0 1 125px', md: '0 1 120px' }}
        minW={0}
        mr="12px"
        fontWeight={600}
        fontSize={{ base: '14px', md: '15px' }}
        lineHeight="1.2"
        whiteSpace="normal"
      >
        {label}
      </Text>
      <Box
        flex="1 1 0"
        fontWeight={700}
        textAlign="right"
        minW={0}
        fontSize={{ base: '14px', md: '15px' }}
        lineHeight="1.2"
        whiteSpace="normal"
        overflowWrap="anywhere"
      >
        {children}
      </Box>
    </Flex>
  );
};

export default chakra(SelfIpoParamRow);
